module.exports = __webpack_public_path__ + "img/home_default_icon.9bfba1f1.svg";